{
  "common": {
    "networkError": "Lỗi mạng — kiểm tra kết nối",
    "retry": "Thử lại",
    "cancel": "Huỷ",
    "close": "Đóng",
    "delete": "Xoá",
    "prev": "Trước",
    "next": "Sau"
  },
  "statusLabels": {
    "pending": "Đang chờ",
    "active": "Hoạt động",
    "failed": "Thất bại",
    "removing": "Đang xoá"
  },
  "healthLabels": {
    "healthy": "khoẻ mạnh",
    "degraded": "suy giảm",
    "down": "ngừng"
  },
  "header": {
    "title": "Brand nền tảng",
    "description": "Vận hành đa thương hiệu: mỗi brand có một website marketing, danh tính người gửi ESP, và (tuỳ chọn) một tên miền ngoài tuỳ chỉnh (Caddy + auto-ACME Let's Encrypt, xác minh CNAME 48h, gia hạn xoá 30 ngày).",
    "reservedBtn": "Xem các subdomain dành riêng",
    "newBtn": "+ Thêm brand"
  },
  "filter": {
    "searchPlaceholder": "Tìm theo tên hoặc tên miền…",
    "statusLabel": "Trạng thái",
    "statusAll": "Tất cả"
  },
  "list": {
    "aria": "Danh sách brand",
    "loading": "Đang tải danh sách brand…",
    "loadFail": "Không tải được: {{message}}",
    "empty": "Chưa có brand nào — bấm \"+ Thêm brand\" để tạo brand mặc định.",
    "defaultBadge": "Mặc định",
    "merchantsHealth_one": "{{count}} merchant · tình trạng {{health}}",
    "merchantsHealth_other": "{{count}} merchant · tình trạng {{health}}",
    "verifyBtn": "Xác minh",
    "deleteBtn": "Xoá",
    "pagination": "Trang {{page}} · {{total}} tổng cộng"
  },
  "detail": {
    "aria": "Chi tiết brand",
    "empty": "Chọn brand ở bên trái để xem chi tiết, theo dõi xác minh DNS, hoặc quản lý danh tính người gửi.",
    "loading": "Đang tải brand…",
    "loadFail": "Không tải được brand.",
    "slugLabel": "slug",
    "editBtn": "Sửa",
    "closeBtn": "Đóng",
    "sectionsAria": "Các mục của brand",
    "tabOverview": "Tổng quan",
    "tabVerify": "Xác minh DNS",
    "tabSender": "Danh tính người gửi",
    "fields": {
      "status": "Trạng thái",
      "tagline": "Khẩu hiệu",
      "primaryColor": "Màu chính",
      "supportEmail": "Email hỗ trợ",
      "termsUrl": "URL điều khoản",
      "privacyUrl": "URL quyền riêng tư"
    }
  },
  "toast": {
    "loadDetailFailTitle": "Không tải được chi tiết brand",
    "brandInUseTitle": "Brand đang được merchant sử dụng",
    "brandInUseDesc_one": "{{count}} merchant đang tham chiếu brand \"{{name}}\". Vui lòng chuyển gán trước khi xoá.",
    "brandInUseDesc_other": "{{count}} merchant đang tham chiếu brand \"{{name}}\". Vui lòng chuyển gán trước khi xoá.",
    "deletedTitle": "Đã xoá brand",
    "deleteFailTitle": "Không xoá được brand",
    "reassignReasonRequiredTitle": "Cần lý do chuyển gán",
    "reassignReasonRequiredDesc": "Lý do tối thiểu 5 ký tự.",
    "reassignSameTitle": "Brand đích trùng nguồn",
    "reassignSameDesc": "Chọn brand đích khác với brand nguồn.",
    "reassignSuccessTitle_one": "Đã chuyển gán {{count}} merchant",
    "reassignSuccessTitle_other": "Đã chuyển gán {{count}} merchant",
    "reassignFailTitle": "Không chuyển gán được"
  },
  "deleteDialog": {
    "title": "Xoá brand?",
    "description": "Xoá \"{{name}}\". Nếu vẫn còn merchant tham chiếu brand này, hệ thống sẽ buộc chuyển gán trước. Thời gian gia hạn xoá 30 ngày áp dụng cho bản ghi DNS."
  },
  "reassign": {
    "title": "Chuyển gán các merchant đang gắn brand",
    "intro_one": "{{count}} merchant đang gắn brand \"{{name}}\". Chọn brand đích và lý do chuyển gán.",
    "intro_other": "{{count}} merchant đang gắn brand \"{{name}}\". Chọn brand đích và lý do chuyển gán.",
    "targetLabel": "Brand đích",
    "targetPlaceholder": "— chọn brand —",
    "reasonLabel": "Lý do (≥5 ký tự)",
    "submit": "Chuyển gán",
    "submitting": "Đang chuyển gán…"
  },
  "reserved": {
    "title": "Subdomain dành riêng",
    "description": "Các slug bên dưới bị chặn khi tạo brand mới. Backend áp dụng cùng danh sách (VG_DOMAIN_RESERVED). Cập nhật ở cả hai nơi khi thêm slug mới."
  },
  "form": {
    "titleCreate": "Brand nền tảng mới",
    "titleEdit": "Sửa brand",
    "stepsAria": "Các bước của trình tạo",
    "themeDefaultName": "Brand mới",
    "steps": {
      "identity": "Định danh",
      "domain": "Tên miền",
      "visual": "Hình ảnh",
      "legal": "Pháp lý",
      "confirm": "Xác nhận"
    },
    "fields": {
      "displayName": "Tên hiển thị của brand",
      "slug": "Slug của brand",
      "slugHint": "Slug dùng cho URL nội bộ. Danh sách dành riêng được áp dụng.",
      "slugImmutable": "Slug không đổi được",
      "reservedChip": "Dành riêng",
      "reservedChipTitle": "\"{{slug}}\" là subdomain dành riêng.",
      "tagline": "Khẩu hiệu",
      "description": "Mô tả",
      "primaryDomain": "Tên miền chính",
      "primaryDomainPlaceholder": "premium.example.com",
      "additionalDomains": "Tên miền bổ sung",
      "additionalDomainsHint": "Mỗi dòng một tên miền (hoặc cách nhau bằng dấu phẩy).",
      "logoUrl": "URL logo",
      "primaryColor": "Màu chính",
      "secondaryColor": "Màu phụ",
      "legalEntityName": "Tên pháp nhân",
      "legalAddress": "Địa chỉ pháp lý",
      "supportEmail": "Email hỗ trợ",
      "termsUrl": "URL điều khoản",
      "privacyUrl": "URL quyền riêng tư"
    },
    "confirm": {
      "heading": "Xem lại & xác nhận",
      "note": "Sau khi tạo, hệ thống sẽ khởi động chu trình xác minh CNAME (Caddy + auto-ACME, timeout 48h theo NG-19). Brand sẽ được chuyển tới trang xác minh DNS.",
      "displayName": "Tên hiển thị",
      "slug": "Slug",
      "primaryDomain": "Tên miền chính",
      "primaryColor": "Màu chính",
      "supportEmail": "Email hỗ trợ"
    },
    "validation": {
      "slugFormat": "Slug chỉ chứa a-z, 0-9, gạch ngang.",
      "slugReserved": "Slug nằm trong danh sách dành riêng.",
      "domainInvalid": "Tên miền không hợp lệ."
    },
    "btn": {
      "back": "Quay lại",
      "next": "Tiếp",
      "saving": "Đang lưu…",
      "saveChanges": "Lưu thay đổi",
      "createBrand": "Tạo brand"
    },
    "toast": {
      "formHasErrorsTitle": "Biểu mẫu còn lỗi",
      "formHasErrorsDesc": "Vui lòng quay lại các bước trước và kiểm tra.",
      "updatedTitle": "Đã cập nhật brand",
      "createdTitle": "Đã tạo brand — chuyển sang xác minh DNS",
      "updateFailTitle": "Không cập nhật được brand",
      "createFailTitle": "Không tạo được brand"
    }
  },
  "verify": {
    "aria": "Bảng xác minh DNS",
    "title": "Xác minh DNS",
    "description": "Caddy + auto-ACME (Let's Encrypt) sẽ tự động cấp chứng chỉ SSL sau khi CNAME được xác minh.",
    "cnameHeading": "Bản ghi CNAME cần tạo:",
    "type": "Type",
    "name": "Name",
    "value": "Value",
    "ttl": "TTL",
    "domainFallback": "(tên miền brand)",
    "verifiedAt": "Đã xác minh lúc {{date}}",
    "lastFailed": "Lần xác minh gần nhất thất bại. Kiểm tra lại CNAME và thử lại.",
    "waiting": "Đang chờ xác minh…",
    "overdue": "Đã quá hạn 48h",
    "countdown": "Còn lại {{hours}}h {{minutes}}m",
    "recheckBtn": "Kiểm tra lại ngay",
    "rechecking": "Đang kiểm tra…",
    "guideSummary": "Hướng dẫn theo nhà cung cấp DNS",
    "guideCloudflare": "Cloudflare — tạo bản ghi CNAME",
    "guideGoDaddy": "GoDaddy — thêm bản ghi CNAME",
    "guideNamecheap": "Namecheap — tạo bản ghi CNAME",
    "toast": {
      "verifiedTitle": "CNAME đã xác minh thành công",
      "notMatchedTitle": "CNAME chưa khớp",
      "observed": "Quan sát được: {{target}}",
      "noRecord": "Chưa tìm thấy bản ghi CNAME nào. Vui lòng kiểm tra nhà cung cấp DNS.",
      "checkFailTitle": "Không kiểm tra được DNS"
    }
  },
  "sender": {
    "aria": "Danh tính người gửi",
    "title": "Danh tính người gửi (SPF / DKIM / DMARC)",
    "description": "Email từ brand này phải vượt qua kiểm tra DMARC alignment. Quản lý chi tiết các alias ở module Sender Identities (task-44).",
    "manageBtn": "Quản lý danh tính người gửi →",
    "loading": "Đang tải danh tính người gửi…",
    "empty": "Chưa có danh tính người gửi nào cho brand này. Tạo alias từ module Sender Identities để hiển thị ở đây.",
    "replyToProvider": "reply-to {{replyTo}} · nhà cung cấp {{provider}}",
    "table": {
      "type": "Type",
      "name": "Name",
      "value": "Value"
    },
    "statusLabels": {
      "pending": "Đang chờ",
      "verified": "Đã xác minh",
      "failed": "Thất bại"
    }
  },
  "theme": {
    "aria": "Xem trước giao diện",
    "title": "Xem trước trực tiếp",
    "scope": "Phạm vi",
    "untitled": "Brand chưa đặt tên",
    "startNow": "Bắt đầu ngay",
    "note": "Xem trước trực tiếp chỉ hiển thị phần header — trang marketing đầy đủ sẽ hiện ra khi task-65 (middleware homepage) ship route"
  }
}
